import { observer } from 'mobx-react';
import { useId } from 'react';

import Link from '../../../../app/shared/components/Link';
import { ProductModelDetailsTranslation } from '../../../localization/ModuleTranslation';
import Brand from '../../../shared/Brand/Brand';
import LoadingStatus from '../../../ui/LoadingStatus/LoadingStatus';
import Markdown from '../../../ui/Markdown/Markdown';
import { SidePanel } from '../../../ui/SidePanel/SidePanel';
import SkeletonText from '../../../ui/SkeletonText/SkeletonText';
import css from './ProductModelDetails.css';
import ProductModelDetailsState from './ProductModelDetailsState';
import ProductModelPricelist from './ProductModelPricelist';

interface ProductModelDetailsProps {
  state: ProductModelDetailsState;
  translation: ProductModelDetailsTranslation;
  onClose: () => void;
}

const ProductModelDetails = observer(({ onClose, state, translation }: ProductModelDetailsProps) => {
  const headingId = useId();
  const { data } = state;

  return (
    <SidePanel className={css.root} closeLabel={translation.closeLabel} onClose={onClose} aria-labelledby={headingId}>
      <Brand className={css.brand} brandId={data.brandId} brandName={data.brandName} />
      <h2 id={headingId} className={css.heading}>
        {data.name}
      </h2>
      {state.isLoading ? (
        <>
          <LoadingStatus message={translation.loadingLabel} />
          <SkeletonText className={css.textBlockSkeleton} lineCount={3} />
          <SkeletonText lineCount={12} />
          <SkeletonText className={css.textBlockSkeleton} lineCount={1} />
        </>
      ) : (
        <>
          {data.keyFeatures && <Markdown className={css.description} content={data.keyFeatures} />}
          <ProductModelPricelist
            displayOptions={data.displayOptions}
            basePrice={data.basePrice}
            netBasePrice={data.netBasePrice}
            priceGroups={data.priceGroups}
            agreementDiscount={state.agreementDiscount}
            translation={translation.pricelist}
          />
          <Link className={css.link} to={state.detailsRouteUrl}>
            {translation.detailsLinkLabel}
          </Link>
        </>
      )}
    </SidePanel>
  );
});

export default ProductModelDetails;
